import type { Mission } from '../missions.ts'

export const ttb: Mission = {
  id: "ttb",
  name: "Alcohol and Tobacco Tax and Trade Bureau",
  short: "TTB",
  call: "Alcohol and Tobacco",
  kind: "subagency",
  parent: "treasury",
  url: "https://www.ttb.gov/",
  established: 2003,
  palette: {
    primary: "#003a6c",
    secondary: "#6c98ef",
    accent: "#f0d52e",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:US-AlcoholAndTobaccoTaxAndTradeBureau-Seal.svg",
  },
  motif: "wheat",
  mission: {
    text: "Collect the taxes on alcohol, tobacco, firearms, and ammunition. Protect the consumer by ensuring the integrity of alcohol products. Ensure only qualified businesses enter the alcohol and tobacco industries. Prevent unfair and unlawful market activity for alcohol and tobacco products.",
    url: "https://www.ttb.gov/about-ttb",
  },
  fact: {
    text: "TTB was created in January 2003, when the Homeland Security Act of 2002 reorganized the Bureau of Alcohol, Tobacco and Firearms and kept its tax collection functions in the Department of the Treasury.",
    url: "https://www.ttb.gov/about-ttb/history",
  },
  seal: {
    file: "public/seals/ttb.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-AlcoholAndTobaccoTaxAndTradeBureau-Seal.svg",
  },
  identifier: {
    about: "https://www.ttb.gov/about-ttb",
    accessibility: "https://www.ttb.gov/about-ttb/accessibility",
    foia: "https://www.ttb.gov/public-information/foia",
    noFear: "https://home.treasury.gov/footer/no-fear-act",
    oig: "https://oig.treasury.gov/",
    performance: "https://www.ttb.gov/about-ttb/plans-and-reports",
    privacy: "https://www.ttb.gov/about-ttb/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/ttb-bourbon-barrels.jpg",
        small: "/media/ttb-bourbon-barrels-sm.jpg",
        alt: "Rows of wooden whiskey barrels stacked on racks along a long, sunlit aisle inside a bourbon distillery warehouse.",
        title: "Bourbon barrels aging in a distillery warehouse, Kentucky, July 10, 2007",
        creator: "Amanda Egan Photography for the National Scenic Byways Program, Federal Highway Administration",
        source: "https://commons.wikimedia.org/wiki/File:Lincoln_Heritage_Scenic_Highway_-_Bourbon_Barrels_in_a_Local_Warehouse_-_NARA_-_7720083.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
